import {ApolloLink, Observable} from '@apollo/client'

export class ActionCableLink extends ApolloLink {
  constructor(cable) {
    super()
    this.cable = cable
  }

  request(operation) {
    return new Observable(observer => {
      let sub = this.cable.subscriptions.create(
        {
          channel: 'GraphqlChannel',
          query: operation.query.loc.source.body,
          variables: operation.variables,
          operationName: operation.operationName
        },
        {
          connected: () => {},
          received: data => {
            if (data.result) {
              observer.next(data.result)
              if (!data.more) {
                observer.complete()
              }
            }
          },
          rejected: () => {
            observer.error(new Error('ActionCable subscription rejected'))
          }
        }
      )

      return () => {
        if (sub) {
          this.cable.subscriptions.remove(sub)
        }
      }
    })
  }
}
